<!-- Header -->
<div class="rn-header" [dir]="_translate.currentLang === 'ar' ? 'rtl' : 'ltr'">
  <div class="rn-header-left">
    <mat-icon class="rn-header-icon">new_releases</mat-icon>
    <div>
      <h2 class="rn-title">{{'COMMON.RELEASE_NOTES' | translate}}</h2>
      <span class="rn-version">v{{ versionNumber }}</span>
    </div>
  </div>
  <button mat-icon-button class="rn-close-btn" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Content -->
<mat-dialog-content class="rn-content" [dir]="_translate.currentLang === 'ar' ? 'rtl' : 'ltr'">
  @if (!modules) {
  <div class="rn-loading">
    <mat-spinner diameter="36"></mat-spinner>
    <p>{{'COMMON.LOADING' | translate}}</p>
  </div>
  }

  @if (modules && modules.length === 0) {
  <div class="rn-empty">
    <mat-icon>info_outline</mat-icon>
    <p>{{'COMMON.NO_DATA' | translate}}</p>
  </div>
  }

  @if (modules && modules.length > 0) {
  <p class="rn-scope-title">{{'COMMON.SCOPE_OF_WORK' | translate}}</p>
  <mat-accordion class="rn-accordion" multi>
    @for (module of modules; track module.name) {
    <mat-expansion-panel class="rn-panel">
      <mat-expansion-panel-header>
        <mat-panel-title class="rn-panel-title">
          <div class="rn-module-icon-wrap">
            <mat-icon>{{module.fontIcon || 'extension'}}</mat-icon>
          </div>
          <span>{{module.name}}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="rn-panel-body" [innerHTML]="module.versionDesc"></div>
    </mat-expansion-panel>
    }
  </mat-accordion>
  }
</mat-dialog-content>